import React from 'react';

import { connect } from 'react-redux';

import { carrierDataSelectors } from 'wanderu-ducks-carriers';
import { tripSummarySelectors } from 'wanderu-ducks-search';
import { tripSelectors } from 'wanderu-ducks-trips';
import { selectLocale } from 'wanderu-i18n';
import { partnerSelectors } from 'wanderu-ducks-partner-data';

import TripSummaryLine from '../../components/TripSummary/TripSummaryLine/TripSummaryLine';

function TripSummaryLineComponent(props) {
    return (
        <TripSummaryLine {...props} />
    );
}

function mapStateToProps(appState, ownProps) {
    const {
        tripId,
        seats,
        wheelchairs,
    } = ownProps;

    const trips = tripSelectors.selectTripSet(appState, tripId);
    const departLeg = trips[0];
    const arriveLeg = trips[trips.length - 1];
    const arrive = tripSelectors.selectTripArriveData(appState, arriveLeg.tripId);
    const depart = tripSelectors.selectTripDepartData(appState, departLeg.tripId);
    const itinerary = tripSummarySelectors.selectItinerary(appState, tripId);
    
    const partnerDetails = partnerSelectors.selectPartnerDetails(appState);
    const showTotalPrice = partnerDetails.affiliateId === 'google';

    const prices = tripSummarySelectors.selectPrices(
        appState,
        [tripId],
        seats,
        wheelchairs,
        showTotalPrice,
    );
    const availableFares = tripSummarySelectors.selectAvailableFares(
        appState,
        tripId,
        seats,
        wheelchairs,
    ) || {};

    const carrierNameMap = trips.reduce((map, trip) => {
        const carrierObj = carrierDataSelectors.selectCarrierData(appState, trip.carrierCode);
        map[trip.tripId] = carrierObj.name;
        return map;
    }, {});

    const hasFlight = tripSelectors.selectHasFlight(appState, tripId);

    const tripIdsWithMismatchedCurrency = tripSummarySelectors
        .selectTripIdsWithMismatchedCurrency(appState, tripId);
    const showCurrencyMismatch = tripIdsWithMismatchedCurrency.length > 0 && !hasFlight;
    const carrierProviderGroup = tripSummarySelectors.selectServiceAttribution(appState, [tripId]);

    return {
        arrive,
        availableFares: availableFares[tripId],
        carrierNameMap,
        depart,
        itinerary,
        prices,
        showCurrencyMismatch,
        trips,
        carrierProviderGroup,
        locale: selectLocale(appState),
    };
}

export {
    mapStateToProps,
};
export default connect(mapStateToProps)(TripSummaryLineComponent);
